export default __webpack_public_path__ + "static/media/Bela_Vista.76afc4e9.webp";